var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.25,
    cy: 35,
    r: 35,
    fill: "#DCFAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_38480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2265 25.2238C50.0989 23.7738 48.3386 23.1281 47.3082 24.1587L45.8364 25.6305C45.5074 25.9595 44.9671 25.9649 44.632 25.6424C44.2843 25.3078 44.3024 24.7313 44.6441 24.3896L46.0917 22.942C47.1211 21.9125 46.4782 20.1516 45.0269 20.0238C41.0825 19.6769 37.9539 23.3453 38.9999 27.2352L21.0817 45.1534C19.9722 46.2629 19.972 48.0589 21.0817 49.1686C22.1887 50.2755 23.9899 50.2756 25.0969 49.1686L43.0104 31.255C46.8539 32.3 50.5771 29.2042 50.2265 25.2238Z",
    fill: "#16DBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1242 26.8825C22.1663 26.9654 22.2211 27.0411 22.2868 27.1067L24.8302 29.6501C25.1735 29.9934 25.7299 29.9933 26.0731 29.6501L27.3666 28.3567L29.8368 30.8269L27.1959 33.4677C26.5116 34.1532 26.5122 35.2682 27.1965 35.9531L27.4736 36.2303L36.4873 27.2172L36.2101 26.94C35.5222 26.2534 34.4124 26.2524 33.7235 26.94L31.0797 29.5839L28.6095 27.1137L29.9029 25.8203C30.2462 25.4771 30.2462 24.9205 29.9029 24.5774L27.3595 22.0339C27.2932 21.9675 27.2165 21.9122 27.1326 21.87L23.8817 20.2369C23.543 20.0668 23.1337 20.1328 22.8657 20.4008L20.6444 22.622C20.3757 22.8907 20.3101 23.3017 20.4819 23.6407L22.1242 26.8825Z",
    fill: "#16DBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6321 35.1199L35.3757 41.3762L42.5607 48.563C44.2892 50.2914 47.0875 50.292 48.8165 48.563C50.5414 46.8381 50.5414 44.0316 48.8165 42.3072L41.6321 35.1199ZM46.7805 46.5252C46.4395 46.8674 45.8815 46.869 45.5378 46.5252L40.5493 41.5368C40.206 41.1934 40.206 40.6368 40.5493 40.2941C40.8927 39.9507 41.4493 39.9507 41.792 40.2941L46.7805 45.2825C47.1238 45.6259 47.1238 46.1818 46.7805 46.5252Z",
    fill: "#16DBCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_38480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20.2498 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsIcon04);
export default __webpack_public_path__ + "static/media/ds_icon_04.c8a7d232e2b99ebdcdc55f3fda37d1f2.svg";
export { ForwardRef as ReactComponent };